import * as React from "react";
import { forwardRef } from "react";
const SvgTwitter = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 32 33", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0.252705 1.68848L12.4579 18.0079L0.175781 31.2764H2.94012L13.6933 19.6595L22.3815 31.2764H31.7883L18.8964 14.0388L30.3285 1.68848H27.5641L17.6614 12.3872L9.65988 1.68848H0.252705ZM4.31807 3.72467H8.6395L27.7226 29.2398H23.4011L4.31807 3.72467Z", fill: "white" }));
const ForwardRef = forwardRef(SvgTwitter);
export default ForwardRef;
